import React from "react";

const IconTextFeature = ({ content }) => {
  const { title, subtitle, icon } = content;
  return (
    <div id="IconTextFeature">
      <div className="wrap">
        <div className="subtitle">{subtitle}</div>
        <div className="title">{title}</div>
        <div className="contentContainer">
          {icon &&
            icon.map((item, index) => (
              <div className="iconTextContainer">
                <div className="icon">
                  <img src={item.icon?.url} alt="" />
                </div>
                <div className="content">
                  <div className="header">
                    <img src={item.header?.url} alt="" />
                  </div>
                  <div className="description">{item.description}</div>
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default IconTextFeature;
